import React from "react";
import { Users } from "lucide-react";

// Gentle collective signal: how many share the intention. Never who, never how much.
export const TogetherLine = ({ t, doneToday }) => {
  const others = Math.max(0, t.count - 1);
  return (
    <div className="mt-3 space-y-1" data-testid="practice-together">
      <p className="inline-flex items-center gap-2 text-sm text-[#e9dcb8]" data-testid="practice-together-count">
        <Users size={14} className="text-[#d7bb7a]" />
        {others ? `You're experiencing this together with ${others} ${others === 1 ? "other" : "others"}.` : "21 Days Together · your invitation is open"}
      </p>
      {doneToday && <p className="text-xs text-[#9fb39a]" data-testid="practice-together-today">Another day together ✓</p>}
      {t.night_offer && <p className="text-xs text-[#8f8a78]" data-testid="practice-together-night-offer">This shared plan includes a Night Installation for members. <a href="/voice-clone" className="underline underline-offset-4 hover:text-[#f3ecd9]">Become a Founding member</a> to add it.</p>}
    </div>
  );
};
